import { ITeamAnalyticsActivityEnum, ITeamAnalyticsActivityV2Enum } from "lib/enum/team-analytics-activity/team-analytics-activity.enum";

export interface UserCountRaw {
    [ITeamAnalyticsActivityEnum.AppId]: string,
    [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
    [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
    [ITeamAnalyticsActivityEnum.UserCount]: string,
  }
  
  export interface UserCountV2Raw {
    [ITeamAnalyticsActivityV2Enum.AppId]: string,
    [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
    [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
    [ITeamAnalyticsActivityV2Enum.UserCount]: string,
  }